<template>
  <div>
    <a-modal
      v-model="visibleRoleModal"
      title="new role"
      @ok="handleCreateRole"
      :okText="editMode ? 'update' : 'create'"
      @cancel="() => toggleRoleModal()"
    >
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="Role Name">
          <a-input
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: 'Please input role name!' }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Description">
          <a-input
            v-decorator="[
              'description',
              {
                rules: [{ required: false }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Active">
          <a-switch
            default-checked
            v-decorator="[
              'active',
              {
                rules: [{ required: false }],
              },
            ]"
          />
        </a-form-item>

        <!-- <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit">
            Submit
          </a-button>
        </a-form-item> -->
      </a-form>
    </a-modal>

    <a-table
      :columns="columns"
      :row-key="(record) => record._id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      bordered
      size="small"
    >
      <template slot="name" slot-scope="name, record">
        <a-button
          color="blue"
          style="cursor:pointer;"
          size="small"
          @click="onSelectRole(record._id, record.name)"
        >
          {{ name }}
        </a-button>
      </template>

      <template slot="bool" slot-scope="bool">
        <a-icon v-if="bool" type="check-circle" class="text-success" />
        <a-icon v-if="!bool" type="close-circle" class="text-danger" />
      </template>
      <template slot="date" slot-scope="date">
        <a-tag color="orange">
          {{ momentom(date) }}
        </a-tag>
      </template>
      <template slot="title" slot-scope="">
        <a-space>
          <a-input-search
            placeholder="search users by name, description"
            style="max-width: 500px"
            enter-button
            size="small"
            @search="onSearch"
          />

          <a-button
            @click="() => fetch()"
            type="dark"
            shape="round"
            icon="reload"
            size="small"
            >reload</a-button
          >

          <a-button
            @click="toggleRoleModal"
            type="default"
            class="bg-success"
            shape="round"
            icon="plus"
            size="small"
            >create role</a-button
          >
        </a-space>
      </template>

      <template slot="actions" slot-scope="item">
        <a-space>
          <a-popconfirm
            title="Sure to delete?"
            @confirm="() => removeRole(item._id)"
          >
            <a-button
              type="danger"
              size="small"
              icon="minus"
              title="remove from role"
            />
          </a-popconfirm>
          <a-button
            @click="() => editRole(item)"
            type="default"
            size="small"
            icon="edit"
            title="edit role"
          />
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";
import { copyTextToClipboard } from "../../utils/common";
import _ from "lodash";
export default {
  data() {
    return {
      visibleRoleModal: false,
      form: this.$form.createForm(this, { name: "roleForm" }),
      columns: [
        {
          title: "role name",
          dataIndex: "name",
          sorter: true,
          //   width: "20%",
          scopedSlots: { customRender: "name" },
        },

        {
          title: "description",
          dataIndex: "description",
        },

        {
          title: "active",
          dataIndex: "active",
          sorter: true,
          scopedSlots: { customRender: "bool" },
        },
        {
          title: "",
          scopedSlots: { customRender: "actions" },
          width: "5%",
        },
        // {
        //   title: "createdAt",
        //   dataIndex: "createdAt",
        //   sorter: true,
        //   scopedSlots: { customRender: "date" },
        //   width: "10%",
        // },
      ],
      editMode: false,
      editId: "",
      pagination: {},
      data: [],
      loading: null,
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;

      const params = {
        pageSize: pagination.pageSize,
        page: pagination.current,
        searchFields: [],
        ...filters,
      };

      if (sorter.order) {
        params.sort =
          sorter.order === "ascend" ? sorter.field : `-${sorter.field}`;
      }
      this.fetch(params);
    },
    fetch(params = {}) {
      this.loading = true;
      this.axios
        .get("/api/roles", {
          params: {
            fields: "_id, name, description, active",

            query: { deleted: { $ne: true }, active: true },

            ...params,
          },
        })
        .then(({ data }) => {
          const pagination = { ...this.pagination };
          // Read total count from server
          pagination.total = data.total;
          // pagination.total = 200;
          this.loading = false;

          this.data = data.rows;
          this.pagination = pagination;
        });
    },
    momentom(input) {
      let date = moment(input);
      return date.fromNow();
    },
    copy(text) {
      copyTextToClipboard(text);
      this.$message.info("copied !");
    },
    onSearch(t, e) {
      if (t) {
        this.fetch({
          searchFields: ["name", "description"],
          search: t,
        });
      } else {
        this.fetch({});
      }
    },
    toggleRoleModal() {
      this.visibleRoleModal = !this.visibleRoleModal;
    },
    handleCreateRole() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.editMode) {
            this.axios
              .put(`/api/roles/${this.editId}`, values)
              .then(({ data }) => {
                this.editMode = false;
                this.editId = "";
                this.$message.info("role updated successfully !");
                this.fetch();
                this.toggleRoleModal();
                this.form = this.$form.createForm(this, { name: "roleForm" });
              })
              .catch((err) => {});
          } else {
            this.axios
              .post("/api/roles", values)
              .then(({ data }) => {
                this.$message.info("role created successfully !");
                this.fetch();
                this.toggleRoleModal();
                this.form = this.$form.createForm(this, { name: "roleForm" });
              })
              .catch((err) => {});
          }
        }
      });
    },
    onSelectRole(roleId, roleName) {
      this.$emit("changed", roleId, roleName);
      console.log(roleId, roleName);
    },
    removeRole(roleId) {
      this.axios.delete(`/api/roles/${roleId}`).then(({ data }) => {
        this.$message.success(`opration success`);
        this.fetch();
      });
    },
    editRole(role) {
      this.editMode = true;
      this.editId = role._id;
      this.form.setFieldsValue(_.omit(role, "_id"));
      this.toggleRoleModal();
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
